/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOListCategoryRecord } from '../models/ApiResponseDTOListCategoryRecord';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CategoryApiService {

    /**
     * Get Category
     * Retrieves a list of categories.
     * @param direction 
     * @returns ApiResponseDTOListCategoryRecord OK
     * @throws ApiError
     */
    public static getCategories(
direction?: 'ASC' | 'DESC',
): CancelablePromise<ApiResponseDTOListCategoryRecord> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/category',
            query: {
                'direction': direction,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

}
